module.exports = __webpack_public_path__ + "img/peopleIcon.bc823390.svg";